export default __webpack_public_path__ + "static/AMJ-Workplace-Wellness-d7df7da287e29888b211a62f791b0c79.webp";